import { FetchWsCatalogueProductTypes } from '@src/reducers/wsCatalogue';
import { getWsCatalogueCurrentView } from '@src/selectors/wsCatalogue';
import { useSelector } from 'react-redux';

import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import OrderDetailsViewer from './OrderDetails';
import ProductDetailsViewer from './ProductDetails';

export const WsCatalogueMenuView: React.FC<{
  titleStyleClassName: string;
}> = ({ titleStyleClassName }) => {
  const WsCatalogueCurrentView = useSelector(getWsCatalogueCurrentView);

  return (
    <>
      {WsCatalogueCurrentView === FetchWsCatalogueProductTypes.PRODUCT && (
        <>
          <Box minHeight={48.1} className={titleStyleClassName}>
            <FormattedMessage id="Ws.Catalogue.product.detail.title" />
          </Box>
          <ProductDetailsViewer />
        </>
      )}

      {WsCatalogueCurrentView === FetchWsCatalogueProductTypes.CART && (
        <>
          <Box minHeight={48.1} className={titleStyleClassName}>
            <FormattedMessage id="Ws.Catalogue.shoppingCart.detail.title" />
          </Box>
          <OrderDetailsViewer />
        </>
      )}
    </>
  );
};

export default WsCatalogueMenuView;
